export function convertCamelCaseToConstName(key) {
  return key
    .replace(/([A-Z])/g, (match, letter) => {
      return '_' + letter;
    })
    .toUpperCase();
}

export function convertConstNameToCamelCase(key) {
  return key
    .toLowerCase()
    .replace(/_([a-z])/g, (match, letter) => {
      return letter.toUpperCase();
    })
    .replace(/_/g, '');
}

export function camelCaseToUnderscore(str) {
  return str.replace(/([A-Z])/g, function($1) {
    return '_' + $1.toLowerCase();
  });
}
